module.exports = __webpack_public_path__ + "static/media/CC_NG_LP_animation_HU.e2bc69b9.gif";